import type { ExternalReactRenderers } from '@wix/da-editor-tiptap/pkg/components/Editor/types';
import DeviationMediaService from '../utils/DeviationMediaService';
import MonoView from './MonoView';
import GalleryView from './GalleryView';
import EmoteSelectorNg from '../EmoteSelectorNg';
import InlineView from './InlineView';

export const externalRenderers: ExternalReactRenderers = {
  deviation: MonoView,
  gallery: GalleryView,
  mediaService: DeviationMediaService,
  emoteSelector: EmoteSelectorNg,
  inline: InlineView,
};
